import { render, staticRenderFns } from "./ModalAcoesDuplicadas.vue?vue&type=template&id=6c0ff464"
import script from "./ModalAcoesDuplicadas.vue?vue&type=script&lang=js"
export * from "./ModalAcoesDuplicadas.vue?vue&type=script&lang=js"
import style0 from "./ModalAcoesDuplicadas.vue?vue&type=style&index=0&id=6c0ff464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports